import { setupI18n } from "@lingui/core";

export const locales = {
  en: "English",
  fr: "Français",
};
export const defaultLocale = "en";

function loadCatalog(locale) {
  return import(`./locales/${locale}/messages.js`);
}

export const i18n = setupI18n();
i18n.willActivate(loadCatalog);
